import { render, staticRenderFns } from "./x-ShengLiShuiKuBengQian.vue?vue&type=template&id=583af7f3&scoped=true"
import script from "./x-ShengLiShuiKuBengQian.vue?vue&type=script&lang=js"
export * from "./x-ShengLiShuiKuBengQian.vue?vue&type=script&lang=js"
import style0 from "./x-ShengLiShuiKuBengQian.vue?vue&type=style&index=0&id=583af7f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583af7f3",
  null
  
)

export default component.exports